import { Component, OnInit, ViewChild, Input, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { CalendarItem, DateRange, CalendarBundle } from '../../core/shared/calendar/calendar.model';
import { CalendarComponent } from '../../core/shared/calendar/calendar.component';
import { GridMainFilter } from '../../core/shared/grid/grid.model';
import { AbsencesRest } from '../absences.rest';
import { SpinnerService } from '../../core/services/spinner-handler/spinner-handler.service';
import { AbsenceRow } from '../absences.model';
import { HolidayCalendar } from '../../configuration/holiday-calendar/holiday-calendar.model';

@Component({
  selector: 'app-absences-calendar',
  templateUrl: './absences-calendar.component.html'
})
export class AbsencesCalendarComponent implements OnInit {
  @Input() mainFilter: GridMainFilter[];
  @Input() showOnlyMonthView: boolean = false;

  @Output() onItemClick = new EventEmitter<any>();
  @Output() onDayClick = new EventEmitter<any>();
  @Output() onPrevClick = new EventEmitter<DateRange>();
  @Output() onNextClick = new EventEmitter<DateRange>();
  @Output() onTodayClick = new EventEmitter<DateRange>();
  @Output() onDateNavClick = new EventEmitter<DateRange>();

  public calendarItems: CalendarItem[] = [];

  @ViewChild(CalendarComponent) calendar: CalendarComponent;

  constructor(
    private absencesRest: AbsencesRest,
    private spinnerService: SpinnerService
  ) { }

  ngOnInit() {
    //this.refreshCalendarData();
  }

  public refreshCalendarData() {
    if (this.mainFilter) {
      this.spinnerService.show();
      this.absencesRest.getAbsencesForCalendar(this.mainFilter).subscribe(calendarBundle => {
        this.parseCalendarItems(calendarBundle);
        this.spinnerService.hide();
      });
    }
  }

  public onItemClickHandler(item: any) {
    this.onItemClick.emit(item);
  }

  public onDayClickHandler(day: any) {
    this.onDayClick.emit(day);
  }

  public onPrevClickHandler(dateRange: DateRange) {
    this.onPrevClick.emit(dateRange);
  }

  public onNextClickHandler(dateRange: DateRange) {
    this.onNextClick.emit(dateRange);
  }

  public onTodayClickHandler(dateRange: DateRange) {
    this.onTodayClick.emit(dateRange);
  }

  public onDateNavHandler(dateRange: DateRange) {
    this.onDateNavClick.emit(dateRange);
  }

  private parseCalendarItems(calendarBundle: CalendarBundle) {
    let newCalendarItems = calendarBundle.absences.map(item => this.convertAbsenceToCalendarItem(item));
    let holidayCalendarItems = calendarBundle.holidays.map(holiday => this.convertHolidayToCalendarItem(holiday));
    newCalendarItems = newCalendarItems.concat(holidayCalendarItems);

    this.calendarItems = newCalendarItems;
  }

  private convertAbsenceToCalendarItem(item: AbsenceRow): CalendarItem {
    let color = this.getColorForAbsenceStatus(item.stateInternalName);
    let startDate = new Date(item.startDate);
    if (!item.endDate) {
      item.endDate = item.startDate;
    }
    let endDate = new Date(item.endDate);
    endDate = new Date(endDate.setHours(0, 0, 0, 0));
    endDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate() + 1);

    let daysCount = item.absenceDays;
    let dayWord = daysCount == 1 ? 'dzień' : 'dni';
    let title = `${item.employeeFullName} (${item.absenceTypeName} [${daysCount} ${dayWord}])`;

    let newItem = {
      title: title,
      start: startDate,
      end: endDate,
      allDay: true,
      color: color
    } as CalendarItem;

    return newItem;
  }

  private convertHolidayToCalendarItem(item: HolidayCalendar): CalendarItem {
    let newItem = {
      start: item.date,
      allDay: true,
      color: '#d7d7d7',
      rendering: 'background'
    } as CalendarItem;

    return newItem;
  }

  private getColorForAbsenceStatus(stateInternalName: string) {
    switch (stateInternalName) {
      case 'Buffered': //niezatwierdzone
        return '#70db70';

      case 'ToBeConfirmed': //do potwierdzenia
        return 'skyblue';

      case 'Accepted': //zaakceptowane
        return '#a9a9a9';

      case 'Rejected': //odrzucone
        return '#ff9980';

      case 'Cancelled': //anulowane
        return '#ff8080';

      default:
        return 'lightgray';
    }
  }
}
